import { render, staticRenderFns } from "./cooperationIntroduction.vue?vue&type=template&id=863a8754&"
import script from "./cooperationIntroduction.vue?vue&type=script&lang=js&"
export * from "./cooperationIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./cooperationIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports